module.exports = __webpack_public_path__ + "img/psd.c983b58c.png";